import { COUNTRY_OPTIONS } from './countryOptions';

export const getCountryBy2LetterCode = code => {
    return COUNTRY_OPTIONS.find(country => country.value === code)?.text || code;
};
